import { render, staticRenderFns } from "./ContactLayout.vue?vue&type=template&id=53271d9c"
import script from "./ContactLayout.vue?vue&type=script&lang=js"
export * from "./ContactLayout.vue?vue&type=script&lang=js"
import style0 from "./ContactLayout.vue?vue&type=style&index=0&id=53271d9c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports